export default {
  id: "route-types",
  title: "Route types explained",
  summary: "Find your vessel, voyages and routes; what active, suggested, reported and draft mean",
  minutes: 3,
  steps: [
    {
      title: "Route types explained",
      text: "In the Fleet Explorer you find every vessel with its voyages and routes. This tour explains what the different route types mean.",
    },
    {
      anchor: "drawer-fleet",
      skipIf: "fleet-panel",
      click: true,
      title: "Open the Fleet Explorer",
      text: "Click <b>Fleet Explorer</b>.",
      side: "right",
    },
    {
      anchor: "fleet-search",
      title: "Search and import",
      text: "Type a vessel name to find it quickly. With <b>Import</b> you can load a route file, e.g. from another planning system.",
      side: "right",
    },
    {
      anchor: "fleet-panel",
      title: "Vessel → voyage → route",
      text: "Everything is organised in three levels:<ul><li><b>Vessel</b>: your ship.</li><li><b>Voyage</b>: one trip of the vessel from a departure port to an arrival port, e.g. Antwerp → Puerto Limón.</li><li><b>Route</b>: a way to sail this voyage. A voyage can have several routes, e.g. a time- and a fuel-optimised one, but only one of them is active.</li></ul>",
      side: "right",
    },
    {
      anchor: "fleet-vessels",
      skipIf: ["fleet-voyages", "fleet-routes"],
      until: ["fleet-voyages", "fleet-routes"],
      title: "Open your vessel",
      text: "Click your vessel in the list.",
      side: "right",
    },
    {
      anchor: "fleet-voyages",
      skipIf: "fleet-routes",
      until: "fleet-routes",
      title: "Voyages",
      text: "Your vessel has no current voyage, so you see the list of its voyages:<ul><li><b>Active</b>: the voyage the vessel is on now.</li><li><b>Archived</b>: a finished voyage, kept for reference.</li><li><b>Plan new voyage</b> opens the Voyage Planner for the next trip. Saving the planned route creates the voyage.</li><li>Older voyages appear with <b>Load older</b> at the bottom.</li></ul>Click a voyage to see its routes.",
      side: "right",
    },
    {
      anchor: "fleet-drill-header",
      title: "The current voyage",
      text: "The header shows your vessel and the voyage you are looking at. If the vessel is on a voyage, METEO TRACKER opens it directly when you click the vessel.<br><br>Click the <b>←</b> arrow to see all voyages of the vessel: finished ones are marked <b>Archived</b>, and <b>Plan new voyage</b> starts the next trip.",
      side: "right",
    },
    {
      anchor: "fleet-reported",
      title: "Reported track (blue)",
      text: "The <b>reported</b> track is where the vessel has actually sailed, built from its position reports. Click it to show or hide it on the map.",
      side: "right",
    },
    {
      anchor: "fleet-routes",
      title: "Route types",
      text: "Each route has a coloured label. The same colour is used for the line on the map:<ul><li><b>Active</b> (green): the route the vessel follows now. Only one route per voyage is active.</li><li><b>Suggested</b> (purple): a proposed alternative, e.g. after a weather update.</li><li><b>Draft</b> (yellow): a new result from the Voyage Planner, not saved yet.</li><li><b>Archived</b> (grey): an older route, kept for reference.</li></ul>",
      side: "right",
    },
    {
      anchor: "fleet-routes",
      title: "Show routes on the map",
      text: "Click a route to show it on the map, click again to hide it. A red <b>⚠</b> means the route has warnings (weather, risk zones). Use the arrow to see more details.",
      side: "right",
    },
    {
      anchor: "route-actions",
      optional: true,
      wait: 1500,
      title: "Route actions",
      text: "The <b>⋮</b> menu of a route lets you change its type (<b>Set as Active</b>, <b>Set as Suggested</b>, <b>Archive</b>), save a draft, rename, export or delete it.",
      side: "left",
    },
    {
      title: "Done",
      text: "Next step: the tutorial <b>Compare routes & set active</b> shows how to compare routes side by side.",
    },
  ],
}
